module.exports = __webpack_public_path__ + "img/category_17.b86de638.png";